import { getAuthContext } from '@/features/auth/auth-session';
import { appConfig } from '@/shared/config/env';
import { ApiError } from '@/services/api/api-error';

export const resolveApiUrl = (input) => {
  const inputUrl = typeof input === 'string' ? input : input.url;

  if (/^https?:\/\//i.test(inputUrl)) {
    return inputUrl;
  }

  const baseUrl = appConfig.apiBaseUrl.replace(/\/$/, '');
  const path = inputUrl.startsWith('/') ? inputUrl : `/${inputUrl}`;
  return `${baseUrl}${path}`;
};

export const authFetch = async (input, init = {}) => {
  const authContext = getAuthContext();
  const headers = new Headers(init.headers || {});

  Object.entries(authContext.headers).forEach(([key, value]) => {
    if (value && !headers.has(key)) {
      headers.set(key, value);
    }
  });

  if (!headers.has('accept')) {
    headers.set('accept', 'application/json');
  }

  return fetch(input, {
    credentials: init.credentials || 'include',
    ...init,
    headers,
  });
};

export const authRequest = async (input, options = {}) => {
  const { json, parseAs = 'json', ...init } = options;
  const headers = new Headers(init.headers || {});
  let body = init.body;

  if (json !== undefined) {
    headers.set('content-type', 'application/json');
    body = JSON.stringify(json);
  }

  const url = resolveApiUrl(input);
  const response = await authFetch(url, {
    ...init,
    headers,
    body,
  });

  if (!response.ok) {
    // body 只能读一次：先取文本再尝试 JSON.parse，避免 .json() 失败后再 .text()
    // 报 "body stream already read"。
    const raw = await response.text().catch(() => '');
    let payload = raw || null;
    try {
      payload = raw ? JSON.parse(raw) : null;
    } catch {
      /* 非 JSON，保留原始文本 */
    }

    throw new ApiError(`API request failed with ${response.status}`, {
      status: response.status,
      payload,
      url,
    });
  }

  if (response.status === 204 || parseAs === 'none') {
    return null;
  }

  if (parseAs === 'text') {
    return response.text();
  }

  return response.json();
};
